// actions.js
import {
  FETCH_COMPONENTS_REQUEST,
  FETCH_COMPONENTS_SUCCESS,
  FETCH_COMPONENTS_FAILURE,
  DELETE_COMPONENTS_REQUEST,
  DELETE_COMPONENTS_FAILURE,
  DELETE_COMPONENTS_SUCCESS,
  FETCH_COMPONENT_REQUEST,
  FETCH_COMPONENT_SUCCESS,
  FETCH_COMPONENT_FAILURE,
  UPDATE_COMPONENTS_REQUEST,
  UPDATE_COMPONENTS_SUCCESS,
  UPDATE_COMPONENTS_FAILURE,
  CLEAR_COMPONENT_ERRORS,
  CLEAR_COMPONENT_SUCCESS,
} from './actionTypes';

export const fetchComponentsRequest = () => ({
  type: FETCH_COMPONENTS_REQUEST,
});

export const fetchComponentsSuccess = (projects) => ({
  type: FETCH_COMPONENTS_SUCCESS,
  payload: projects,
});

export const fetchComponentsFailure = (error) => ({
  type: FETCH_COMPONENTS_FAILURE,
  payload: error,
});

export const fetchComponentRequest = (id) => ({
  type: FETCH_COMPONENT_REQUEST,
  payload: id
});

export const fetchComponentSuccess = (project) => ({
  type: FETCH_COMPONENT_SUCCESS,
  payload: project,
});

export const fetchComponentFailure = (error) => ({
  type: FETCH_COMPONENT_FAILURE,
  payload: error,
});

export const updateComponentRequest = (project, navigate) => ({
  type: UPDATE_COMPONENTS_REQUEST,
  payload: { project, navigate }
});

export const updateComponentSuccess = () => ({
  type: UPDATE_COMPONENTS_SUCCESS,
});

export const updateComponentFailure = (error) => ({
  type: UPDATE_COMPONENTS_FAILURE,
  payload: error,
});

export const deleteComponentRequest = (id) => ({
  type: DELETE_COMPONENTS_REQUEST,
  payload: id
});

export const deleteComponentSuccess = (id) => ({
  type: DELETE_COMPONENTS_SUCCESS,
  payload: id,
});

export const deleteComponentFailure = (error) => ({
  type: DELETE_COMPONENTS_FAILURE,
  payload: error,
});

export const clearComponentErrors = () => ({
  type: CLEAR_COMPONENT_ERRORS,
});

export const clearComponentSuccess = () => ({
  type: CLEAR_COMPONENT_SUCCESS,
});